export const appConfig = {
    env: process.env.REACT_APP_ENV,
    assetsUrl: 'https://assets.vitastudent.com/concierge',
    backend: process.env.REACT_APP_STUDENT_BOOKING_BACKEND_URL,
    auth0: {
        authDomain: process.env.REACT_APP_AUTH0_DOMAIN,
        authAudience: process.env.REACT_APP_AUTH0_AUDIENCE,
        authClientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    },
    myAccountUrl: process.env.REACT_APP_MY_ACCOUNT_URL,
    pdfGeneratorUrl: process.env.REACT_APP_LICENCE_AGREEMENT_URL,
    brochureSiteUrl: {
        vs: process.env.REACT_APP_BROCHURE_SITE_URL,
        hos: process.env.REACT_APP_BROCHURE_SITE_URL_HOS,
    },
    vitaStudentDomain: process.env.REACT_APP_VITA_STUDENT_DOMAIN,
    houseOfSocialDomain: process.env.REACT_APP_HOS_DOMAIN,
};
